import { render, staticRenderFns } from "./ModalAutoGeneratePolicyWizard.vue?vue&type=template&id=4e0acf06&"
import script from "./ModalAutoGeneratePolicyWizard.vue?vue&type=script&lang=js&"
export * from "./ModalAutoGeneratePolicyWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports